import ApiBack from "../../../utils/domains/ApiBack";
import IPS from "../../../models/Ips";
import IPSView from "../../../models/ipsView";
import Municipio from "../../../models/municipio";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ServicePrivate from "../../../services/ServicePrivate";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { MessageToastify } from "../../../utils/funtions/MessageToastify";
import { useForm } from "../../../utils/hooks/useForm";
import { useRef } from "react";
import Deparment from "../../../models/Deparment";
import User from "../../../models/user";
import { jwtDecode } from "jwt-decode";
import { Bell } from "lucide-react";

export const ViewIps = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [process, setProcess] = useState<boolean>(false);
  const [dateContract, setDateContract] = useState("");
  const [dateUpdate2025, setDateUpdate2025] = useState("");
  const [dateUpdated2025, setDateUpdated2025] = useState("");
  const [arrayjIps, setArrayIps] = useState<IPSView[]>([]);
  const [proccess, setProccess] = useState<boolean>();
  const [showFinal, setShowFinal] = useState(false);
  const [show, setShow] = useState(false);
  const [showData, setShowData] = useState(false);
  const [show2, setShow2] = useState(false);
  const [showNoti, setShowNoti] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showUpActivation, setShowUpActivation] = useState(false);
  type formaHtml = React.FormEvent<HTMLFormElement>;
  const handleClose = () => setShow(false);
  const handleCloseData = () => setShowData(false);
  const handleClose2 = () => setShow2(false);
  const handleCloseUpdate = () => setShowUpdate(false);
  const handleCloseUpdateActivation = () => setShowUpActivation(false);
  const formRef = useRef<HTMLFormElement>(null);
  const [arrayMunicipio, setArrayMunicipio] = useState<Municipio[]>([]);
  const [haveLovelace, setHaveLovelace] = useState(false);
  const [haveMovile, setHaveMovile] = useState(false);
  const [haveActualization, setHaveActialization] = useState(false);
  const [dataA, setDataA] = useState("");
  const [connectiono, setConnection] = useState("");
  const [passwordServer, setPasswordServer] = useState("");
  const [nameServer, setNameServer] = useState("");
  const [passwordConnection, setPasswordConnection] = useState("");
  //function to error the Token on the time, using when token is invalid or expired
  const [search, setSearch] = useState("");
  const [arrayUsers, setArrayUsers] = useState<User>();
  const [resumen, setResumen] = useState<any>({});
  const [objIps, setObjIps] = useState<IPS>();
  const [arrayIPSUpdate, setArrayIPSUpdate] = useState<IPS[]>([]);
  const [sortConfig, setSortConfig] = useState<{ field: string; order: "asc" | "desc" }>({
    field: "",
    order: "asc",
  });



  let { nombre_ips, cod_ips, id_municipio_id, count_movile, connection, password_connection, name_server, password_server, doubleLink, object } =
    useForm<IPS>(
      new IPS(
        0,
        "",
        "",
        true,
        new Municipio(0, "", "", new Deparment(0, "")),
        0,
        new Date(),
        false, new Date(), true, true, "", "", "", "", "", "", "", false
      ) // Incluye `id_municipio` con un valor inicial
    );

  const [objips, setObjips] = useState<IPSView>(
    new IPSView(
      0,
      "",
      "",
      false,
      new Municipio(0, "", "", new Deparment(0, "")),
      new Date(),
      false,
      "",
      new Date(), true, true, "", ""
    )
  );

  const cleanBox = (form: HTMLFormElement) => {
    form.reset();

    object.connection = "";
    object.password_connection = "";
    object.password_server = "";
    object.name_server = "";

    (form.querySelector('[name="name_solicited"]') as HTMLInputElement).value =
      "";
    (form.querySelector('[name="role2"]') as HTMLInputElement).value = "";
    (form.querySelector('[name="number"]') as HTMLInputElement).value = "";
    (form.querySelector('[name="requirement"]') as HTMLInputElement).value = "";

    form.classList.remove("was-validated");
  };


  // Filtrar los datos según búsqueda
  const filteredIps = arrayjIps.filter((ips) => {
    if (!search) return true; // si no hay búsqueda, no filtramos nada
    const term = search.toLowerCase().trim();
    return (
      ips.nombre_ips.toLowerCase().includes(term) ||
      ips.cod_ips?.toString().toLowerCase().includes(term) ||
      ips.municipio_id__nombre_municipio.toLowerCase().includes(term)
    );
  });
  const [sortedIps, setSortedIps] = useState(filteredIps);
  const handleTokenError = () => {
    navigate("/");
  };

  const updateSupportDetails = async (myipsid: number, isActive: boolean) => {
    setProccess(true);

    try {
      // Encuentra el soporte por ID en el array
      const updatedSupport = arrayjIps.find((myIps) => myIps.id === myipsid);

      if (!updatedSupport) {
        console.error("Soporte no encontrado");
        return;
      }

      // Crea un objeto con el valor de is_active basado en el parámetro
      const updatedObject = {
        is_active: isActive,
      };

      const urlUpdate = ApiBack.IPS_UPDATED + "/" + myipsid;
      const response = await ServicePrivate.requestPUT(
        urlUpdate,
        updatedObject
      );

      if (response.data.OK) {
        MessageToastify(
          "error",
          "Error en el momento de Actualizar el estado de la IPS.",
          7000
        );
        getAllIPS();
      } else {
        MessageToastify("success", "El estado de la IPS esta actualizado correctamente.", 3000);
        setShowFinal(false);
        getAllIPS();
      }
    } catch (error) {
      console.error("Error actualizando el ID del usuario:", error);
      MessageToastify(
        "error",
        "Error en el momento de Actualizar el estado de la IPS en el servidor.",
        7000
      );
      setShow(false);
    } finally {
      setProccess(false);
      setShow(false);
    }
  };

  const getOneIps = async (id: number) => {
    try {
      const urlGetUser = ApiBack.IPS_LIST_ONE + "/" + id;
      const result = await ServicePrivate.requestGET(urlGetUser);
      setObjips(result);
      setShow(true);
    } catch (error) {
      console.error("Error fetching profesional:", error);
      setShow(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError(); // Manejar el error de token
      }
    }
  };

  const getMunicipality = async () => {
    try {
      const urlGetMunc = ApiBack.MUNICIPIOS_LIST;
      const result = await ServicePrivate.requestGET(urlGetMunc);
      setArrayMunicipio(result);
    } catch (error) {
      console.error("Error fetching profesional:", error);
      setShow(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError(); // Manejar el error de token
      }
    }
  };
  const getIPSUpdate = async () => {
    try {
      const urlGetMunc = ApiBack.IPS_UPDATE_STATUS;
      const result = await ServicePrivate.requestGET(urlGetMunc);

      if (result) {
        setArrayIPSUpdate(result);
      }
      if (result.error) {
        MessageToastify("error", result.error, 3000)
      }
    } catch (error) {
      console.error("Error fetching profesional:", error);
      setShow(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError(); // Manejar el error de token
      }
    }
  };

  const handleShowCreate = async () => {
    setShow2(true);
    getMunicipality();

  }

  const getOneIpsUp = async (id: number) => {
    try {
      const urlGetUser = ApiBack.IPS_LIST_ONE + "/" + id;
      const result = await ServicePrivate.requestGET(urlGetUser);
      setObjips(result);
      setShowUpdate(true);
      setDateContract(result.date_contract)
      setDateUpdate2025(result.date_update2025)
      setHaveActialization(result.have_actualization)
      setConnection(result.connection)
      setPasswordConnection(result.password_connection)
      setNameServer(result.name_server)
      setPasswordServer(result.password_server)
      console.log(result);

    } catch (error) {
      console.error("Error fetching profesional:", error);
      setShow(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError(); // Manejar el error de token
      }
    }
  };

  const getOneIpsUpDateA = async (id: number) => {
    try {
      const urlGetUser = ApiBack.IPS_LIST_ONE_ACTIVATE + "/" + id;
      const result = await ServicePrivate.requestGET(urlGetUser);
      setObjips(result);
      setShowUpActivation(true);
      setDataA(result.data_a)
    } catch (error) {
      console.error("Error fetching profesional:", error);
      setShow(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError(); // Manejar el error de token
      }
    }
  };

  const getOneDataIps = async (id: number) => {
    try {
      const urlGetUser = ApiBack.IPS_LIST_ONE_DATA + "/" + id;
      const result = await ServicePrivate.requestGET(urlGetUser);
      setObjIps(result);
      setShowData(true);
    } catch (error) {
      console.error("Error fetching profesional:", error);
      setShow(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError(); // Manejar el error de token
      }
    }
  };

  const getAllIPS = async () => {
    try {
      const results = await ServicePrivate.requestGET(ApiBack.IPS_VIEW_ALL);

      if (results) {
        const payload = results.data || [];
        const resumen = results.resumen || {};
        setArrayIps(payload);
        setResumen(resumen)
      } else {
        setLoading(true);
      }
    } catch (error) {
      console.error("Error fetching IPS:", error);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError();
      }
    }
  };


  const getProfessionals = async () => {
    try {
      const token: any = localStorage.getItem("access");
      if (!token) {
        handleTokenError();
        return;
      }
      const decoded: any = jwtDecode(token);

      if (decoded && decoded.role) {
        setArrayUsers(decoded);
        setLoading(false);
        return;
      } else {
        console.error("El token no contiene información de usuario válida.");
        handleTokenError();
      }

    } catch (error) {
      console.error("Error fetching professionals:", error);
      setLoading(false);
      const token = localStorage.getItem("access");
      if (token === null) {
        handleTokenError();
      }
    }
  };

  const sendUpdated = async (Id: number, dateContract: string) => {
    setProccess(true);
    try {
      // Encuentra el soporte en el array
      const findIps = arrayjIps.find((prof) => prof.id === Id);

      if (!findIps) {
        MessageToastify(
          "error",
          "No se encuentra la IPS en la base de datos.",
          7000
        );
        return;
      }
      if (dateContract !== "" || dateContract !== null) {
        const today = new Date();
        const eightDaysAgo = new Date(today);
        eightDaysAgo.setDate(today.getDate() - 365);


        const selectedDate = new Date(dateContract);
        if (selectedDate < eightDaysAgo) {
          MessageToastify(
            "error",
            "La fecha no puede ser menor a 1 año menor a hoy.",
            2000
          );
          return;
        } else if (selectedDate > today) {
          MessageToastify(
            "error",
            "La fecha no puede superar la fecha actual.",
            2000
          );
          return;
        }
      }
      // Crear el objeto con el id que deseas actualizar
      const updatedObject = {
        date_contract: dateContract,
        date_update2025: dateUpdate2025,
        have_lovelace: haveLovelace,
        have_movile: haveMovile,
        count_movile: count_movile,
        date_updated2025: dateUpdated2025,
        connection: connectiono,
        password_connection: passwordConnection,
        name_server: nameServer,
        password_server: passwordServer,
        have_actualization: haveActualization
      };

      const urlUpdate = ApiBack.IPS_UPDATE_CONTRACT + "/" + Id;

      const response = await ServicePrivate.requestPUT(
        urlUpdate,
        updatedObject
      );

      if (response?.status === 200) {
        MessageToastify(
          "success",
          "Se ha actualizado los datos cambiandos.",
          7000
        );
        setShowUpdate(false);
        getAllIPS();
        getIPSUpdate();
      } else {
        MessageToastify(
          "success",
          "Error al actualizar los datos.",
          3000
        );

      }
    } catch (error) {
      console.error("Error actualizando el ID del usuario:", error);
      MessageToastify(
        "error",
        "Error al enviar la nueva fecha del contrato por parte del servidor comuniquese con TI.",
        7000
      );
    } finally {
      setProccess(false);
    }
  };

  const sendUpdatedDataA = async (Id: number) => {
    setProccess(true);
    try {
      // Encuentra el soporte en el array
      const findIps = arrayjIps.find((prof) => prof.id === Id);

      if (!findIps) {
        MessageToastify(
          "error",
          "No se encuentra la IPS en la base de datos.",
          7000
        );
        return;
      }

      // Crear el objeto con el id que deseas actualizar
      const updatedObject = {
        data_a: dataA
      };

      const urlUpdate = ApiBack.IPS_UPDATE_DATA_A + "/" + Id;

      const response = await ServicePrivate.requestPUT(
        urlUpdate,
        updatedObject
      );
      if (response?.status === 200) {
        MessageToastify(
          "success",
          "Los datos de la activación están actualizados.",
          2000
        );
        setShowUpActivation(false);
        getAllIPS();
      } else {
        MessageToastify(
          "success",
          "Error al actualizar los datos de la activación.",
          3000
        );

      }
    } catch (error) {
      console.error("Error actualizando el ID del usuario:", error);
      MessageToastify(
        "error",
        "Error al enviar la nueva fecha del contrato por parte del servidor comuniquese con TI.",
        7000
      );
    } finally {
      setProccess(false);
    }
  };

  const sendForm = async (fh: formaHtml) => {
    try {
      fh.preventDefault();
      setProcess(true);
      const form = fh.currentTarget;

      form.classList.add("was-validated");

      if (form.checkValidity() === false) {
        fh.preventDefault();
        fh.stopPropagation();
        setProcess(false);
        MessageToastify(
          "error",
          "Por favor, completa todos los campos requeridos.",
          7000
        );
        return;
      }

      const formData = {
        nombre_ips: object.nombre_ips,
        cod_ips: object.cod_ips,
        is_active: true,
        id_municipio_id: object.id_municipio_id,
      };

      const response = await ServicePrivate.requestPOST(
        ApiBack.IPS_CREATE,
        formData
      );

      if (response.OK) {
        setProcess(false);
        MessageToastify(
          "error",
          "error al momento de crear el nuevo cliente.",
          5000
        );
      } else {
        setProcess(false);
        handleClose2();
        getAllIPS();
        MessageToastify("success", "EL nuevo cliente ha sido creado.", 5000);
      }
    } catch (error) {
      setProcess(false);

      MessageToastify(
        "error",
        "Error en el momento  crear el nuevo cliente.",
        7000
      );
    }
  };



  const handleSort = (field: "date_contract" | "date_update2025") => {
    // setSortField(field);

    const sorted = [...filteredIps].sort((a, b) => {
      const valA = a[field] ? new Date(a[field]).getTime() : 0;
      const valB = b[field] ? new Date(b[field]).getTime() : 0;
      return valB - valA ; 
    });

    setSortedIps(sorted);
  };

  useEffect(() => {
    getAllIPS();
    getProfessionals();
    getIPSUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div>
        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-4 col-sm-4">
                    <h4 className="card-title fs-4">
                      <i className="fa-solid fa-list"></i>&nbsp;Listado de
                      clientes
                    </h4>

                  </div>
                  <div className="col-lg-4 col-sm-4">
                    <input
                      type="text"
                      placeholder="Buscar IPS por municipio o por nombre."
                      className="form-control mb-2"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="col-lg-4 col-sm-4">
                    <div className="d-flex justify-content-center justify-content-md-end py-2 p-md-0">
                      <div className="position-relative d-inline-block">
                        <button
                          type="button"
                          className="btn btn-link position-relative p-2"
                          onClick={() => { setShowNoti(!showNoti); }}
                        >
                          <Bell className="h-5 w-5 text-dark" strokeWidth={2.5} />
                          {arrayIPSUpdate.length > 0 && (
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark">
                              {arrayIPSUpdate.length}
                            </span>
                          )}
                        </button>
                        {showNoti && (
                          <div
                            className="position-absolute ps-3 pe-3 shadow-lg rounded-4 notification-bubble"
                            style={{
                              position: "absolute",
                              top: "40px",
                              right: "0px",
                              minWidth: "20vh",
                              maxHeight: "40vh",
                              overflowY: "auto",
                              background: "#fff",
                              zIndex: 1800,
                            }}
                          >
                            <div
                              className="sticky-header"
                              style={{
                                background: "#fff",
                                borderBottom: "1px solid #dee2e6",
                                position: "sticky",
                                top: "0px",
                                zIndex: 10,
                                padding: "0.5rem 1rem",  // más compacto
                                marginTop: "0px",
                              }}
                            >
                              <h6 className="fw-bold m-0" style={{ fontSize: "0.95rem" }}>
                                IPS con pendientes
                              </h6>
                            </div>

                            <div
                              style={{
                                overflowY: "auto",
                                flex: 1,
                                padding: "5px",
                              }}
                            >
                              {arrayIPSUpdate.length > 0 ? (
                                arrayIPSUpdate.map((n) => (
                                  <div
                                    key={n.id}
                                    className="dropdown-item d-flex justify-content-between"
                                  >
                                    <span>{n.nombre_ips}</span>
                                  </div>
                                ))
                              ) : (
                                <div className="dropdown-item text-muted">
                                  No hay IPS con pendientes.
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      <button
                        className={
                          "badge fs-6 py-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                        }
                        type="button"
                        onClick={() => handleShowCreate()}
                        style={{ marginLeft: "10px" }}
                      >
                        <i className="fa-solid fa-plus"></i>&nbsp;Crear
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row d-flex justify-center">
                  <div className="col-lg-2 col-md-2">
                    <p>
                      Total de ips:&nbsp;
                      <b className="fw-bold">{resumen.total_ips}</b>
                    </p>
                  </div>
                  <div className="col-lg-2 col-md-3">
                    <p>
                      Total de ips activas:&nbsp;
                      <b className="fw-bold">{resumen.total_activas}</b>
                    </p>
                  </div>
                  <div className="col-lg-2 col-md-3">
                    <p>
                      Cantidad de contrato S/C:&nbsp;
                      <b className="fw-bold">{resumen.total_contrato}</b>
                    </p>
                  </div>
                  <div className="col-lg-2 col-md-3">
                    <p>
                      Cantidad de actualizadas 2025:&nbsp;
                      <b className="fw-bold">{resumen.total_actualizadas}</b>
                    </p>
                  </div>
                </div>

                <div className="table-responsive rounded-table" style={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  zIndex: 1020
                }}>

                  <table className="table table-striped table-sm table-hover table-sm">
                    <thead className="table-dark " style={{ position: "sticky", top: 0, zIndex: 10 }}>
                      <tr>
                        <th style={{ width: "5%", cursor: "pointer" }} >Municipio</th>
                        <th style={{ width: "25%" }}>Nombre IPS</th>
                        <th style={{ width: "10%" }}>Cod. IPS</th>
                        <th style={{ width: "15%", cursor: "pointer" }} onClick={() => (handleSort("date_contract"))}>Contrato S/C</th>
                        <th
                          style={{ width: "15%", cursor: "pointer" }}
                          onClick={() => (handleSort("date_update2025"))}
                        >
                          Actualización 2025
                        </th>
                        <th style={{ width: "18%" }}>Activación</th>
                        <th style={{ width: "12%" }}>Estado</th>
                      </tr>
                    </thead>
                    <tbody className="table-group-divider ">
                      {(sortedIps.length > 0 ? sortedIps : filteredIps).map((myIps, count) => (
                        <tr key={count + 1}>
                          <td>{myIps.municipio_id__nombre_municipio}</td>
                          <td>{myIps.nombre_ips}</td>
                          <td>{myIps.cod_ips}</td>
                          <td>
                            {myIps.date_contract
                              ? new Date(`${myIps.date_contract}T00:00:00`).toLocaleString(
                                "es-CO",
                                {
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                }
                              )
                              : "No Tiene contrato"}
                          </td>
                          <td>
                            {myIps.date_update2025
                              ? new Date(`${myIps.date_update2025}T00:00:00`).toLocaleString(
                                "es-CO",
                                {
                                  year: "numeric",
                                  month: "2-digit",
                                  day: "2-digit",
                                }
                              )
                              : "No Tiene contrato"}
                          </td>
                          <td>{myIps.data_a}</td>
                          <td>
                            <button
                              className={`badge fs-6 align-items-center p-1 pe-1 rounded-pill border ${myIps.is_active
                                ? "text-info-emphasis bg-info-subtle border-info-subtle"
                                : "text-secondary bg-secondary-subtle border-secondary"
                                }`}
                              onClick={() => getOneDataIps(myIps.id)}
                              disabled={!myIps.is_active}
                            >
                              <i className="fa-solid fa-info"></i>
                            </button>
                            &nbsp;
                            <button
                              className={`badge fs-6 align-items-center p-1 pe-1 rounded-pill border ${myIps.is_active
                                ? "text-dark-emphasis bg-dark-subtle border-dark-subtle"
                                : "text-secondary bg-secondary-subtle border-secondary"
                                }`}
                              onClick={() => getOneIpsUp(myIps.id)}
                              disabled={!myIps.is_active}
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </button>
                            &nbsp;
                            <button
                              className={`badge fs-6 align-items-center p-1 pe-1 rounded-pill border ${myIps.is_active
                                ? "text-primary-emphasis bg-primary-subtle border-primary-subtle"
                                : "text-secondary bg-secondary-subtle border-secondary"
                                }`}
                              onClick={() => getOneIpsUpDateA(myIps.id)}
                              disabled={!myIps.is_active}
                            >
                              <i className="fa-solid fa-a"></i>
                            </button>
                            &nbsp;
                            {arrayUsers?.role === "ADMINISTRADOR" ? (
                              <>
                                <button
                                  className={
                                    myIps.is_active
                                      ? "badge fs-6 py-1 pe-1 text-danger-emphasis bg-danger-subtle border border-danger-subtle rounded-pill"
                                      : "badge fs-6 py-1 pe-3 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                  }
                                  type="button"
                                  onClick={() => getOneIps(myIps.id)}

                                >
                                  {myIps.is_active ? (
                                    <>
                                      <i className="fa-regular fa-circle-xmark"></i>
                                      &nbsp;Inactivar
                                    </>
                                  ) : (
                                    <>
                                      <i className="fa-regular fa-circle-check"></i>
                                      &nbsp;Activar
                                    </>
                                  )}
                                </button>
                              </>
                            ) : ("")}

                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="d-flex align-items-center justify-content-center m-3"></div>
                </div>

                <Modal
                  show={show}
                  onHide={handleClose}
                  backdrop="static"
                  keyboard={false}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="text-center fw-bold">
                      {objips.is_active ? "Inactivar la IPS" : "Activar la IPS"}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    ¿Realmente desea cambiar el estado de la IPS?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="danger"
                      onClick={() => {
                        setShow(false);
                      }}
                    >
                      <i className="fa-solid fa-backward"></i>
                      &nbsp;Cancelar
                    </Button>
                    <Button
                      variant="success"
                      onClick={() => {
                        updateSupportDetails(objips.id, !objips.is_active);
                      }}
                    >
                      <i className="fa-solid fa-circle-check"></i>
                      &nbsp;Confirmar
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={showData}
                  onHide={handleCloseData}
                  backdrop="static"
                  keyboard={false}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  size="xl"
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="text-center fw-bold">
                      Datos de la ips
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Card className="mt-0 border-0 shadow-none">
                      {/* card body */}
                      <Card.Body>
                        {/* card title */}
                        <Card.Title
                          as="h4"
                          className="d-flex justify-content-center fs-2"
                        >
                          <i className="fa-solid fa-hospital-user"></i>
                          &nbsp;IPS
                        </Card.Title>
                        <span
                          className="text-uppercase fw-lighter  fs-6 ls-2"
                          style={{ color: "#0f0f70" }}
                        >
                          <i className="fa-solid fa-clipboard-check"></i> Nombre de la ips:{" "}
                          <p className="fw-semibold text-black fs-5">
                            {objIps?.nombre_ips}
                          </p>
                        </span>
                        <Row>
                          <Col xs={8} className="mb-1">
                            <h6
                              className="text-uppercase fs-6 fw-lighter ls-2"
                              style={{ color: "#0f0f70" }}
                            >
                              <i className="fa-regular fa-id-card"></i> Código Ips
                            </h6>
                            <p className="fw-semibold fs-5 text-black">
                              {objIps?.cod_ips}
                            </p>
                          </Col>
                          <Col xs={4} className="mb-1">
                            <h6
                              className="text-uppercase fs-6 fw-lighter ls-2"
                              style={{ color: "#0f0f70" }}
                            >
                              <i className="fa-solid fa-calendar"></i> Contrato S/C
                            </h6>
                            <p className="fw-semibold fs-5 text-black">
                              {objIps?.date_contract
                                ? new Date(`${objIps.date_contract}T00:00:00`).toLocaleString(
                                  "es-CO",
                                  {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  }
                                )
                                : "No Tiene contrato"}
                            </p>
                          </Col>
                          <Col xs={6}>
                            <h6
                              className="text-uppercase fw-lighter fs-6 ls-2"
                              style={{ color: "#0f0f70" }}
                            >
                              <i className="fa-regular fa-envelope"></i> Fecha de actualización y actualizado
                            </h6>
                            <p className="fw-semibold fs-5 text-black">
                              {objIps?.date_update2025
                                ? new Date(`${objIps.date_contract}T00:00:00`).toLocaleString(
                                  "es-CO",
                                  {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  }
                                )
                                : "No Tiene actualización"}&nbsp;
                              {objIps?.date_updated
                                ? new Date(`${objIps.date_updated}T00:00:00`).toLocaleString(
                                  "es-CO",
                                  {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  }
                                )
                                : "No Tiene actualizada"}
                            </p>
                          </Col>
                          <Col xs={6}>
                            <h6
                              className="text-uppercase fw-lighter fs-6 ls-2"
                              style={{ color: "#0f0f70" }}
                            >
                              <i className="fa-regular fa-envelope"></i> Conexión
                            </h6>
                            <p className="text-uppercase fw-semibold fs-5 text-black">
                              {objIps?.connection}
                            </p>
                          </Col>
                          <Col xs={6} className="mb-1">
                            <h6
                              className="text-uppercase fw-lighter fs-6 ls-2"
                              style={{ color: "#0f0f70" }}
                            >
                              <i className="fa-solid fa-phone-volume"></i> Contraseña de la conexión
                            </h6>
                            <p className="fw-semibold fs-5 text-black">
                              {objIps?.password_connection}
                            </p>
                          </Col>
                          <Col xs={6} className="mb-1">
                            <h6
                              className="text-uppercase fw-lighter fs-6 ls-2"
                              style={{ color: "#0f0f70" }}
                            >
                              <i className="fa-solid fa-phone-volume"></i> Nombre del servidor
                            </h6>
                            <p className="fw-semibold fs-5 text-black">
                              {objIps?.name_server}
                            </p>
                          </Col>
                          <Col xs={12}>
                            <h6
                              className="text-uppercase fw-lighter fs-6 ls-2"
                              style={{ color: "#0f0f70" }}
                            >
                              <i className="fa-regular fa-envelope"></i> Contraseña del servidor
                            </h6>
                            <p className="text-uppercase fw-semibold fs-5 text-black">
                              {objIps?.password_server}
                            </p>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="danger"
                      onClick={() => {
                        setShowData(false);
                      }}
                    >
                      <i className="fa-solid fa-backward"></i>
                      &nbsp;Cerrar
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={show2}
                  onHide={handleClose2}
                  backdrop="static"
                  keyboard={false}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="text-center fw-bold">
                      <i className="fa-solid fa-folder-plus"></i>
                      &nbsp;Formulario de creación
                    </Modal.Title>
                  </Modal.Header>
                  <Form
                    className="forms-sample"
                    validated={process}
                    onSubmit={sendForm}
                    noValidate
                    ref={formRef}
                  >
                    <Modal.Body>
                      {/* Campo para nombre_ips */}
                      <Form.Group controlId="nombre_ips" className="mb-3 w-100">
                        <Form.Label
                          className="fw-bold mb-2 mt-2"
                          htmlFor="nombre_ips"
                        >
                          Nombre IPS:
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="nombre_ips"
                          className="form-control"
                          id="nombre_ips"
                          placeholder="Escriba el nombre de la IPS"
                          value={nombre_ips}
                          onChange={(e) => {
                            let value = e.target.value.toUpperCase(); // Convierte a mayúsculas
                            // Validar que solo contenga letras y limitar a 60 caracteres
                            if (
                              /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]*$/.test(value) &&
                              value.length <= 60
                            ) {
                              e.target.value = value; // Establece el valor en mayúsculas
                              doubleLink(e); // Llama a tu función existente
                            }
                          }}
                          autoComplete="off"
                          maxLength={60} // Limita a 60 caracteres
                        />
                        <Form.Control.Feedback type="invalid">
                          Nombre de la IPS es obligatorio.
                        </Form.Control.Feedback>
                      </Form.Group>

                      {/* Campo para cod_ips */}
                      <Form.Group controlId="cod_ips" className="mb-3 w-100">
                        <Form.Label
                          className="fw-bold mb-2 mt-2"
                          htmlFor="cod_ips"
                        >
                          Código IPS:
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="cod_ips"
                          className="form-control"
                          id="cod_ips"
                          placeholder="Escriba el código de la IPS"
                          value={cod_ips}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Permitir solo números y limitar a 20 caracteres
                            if (/^\d*$/.test(value) && value.length <= 20) {
                              doubleLink(e); // Llama a tu función existente
                            }
                          }}
                          autoComplete="off"
                          maxLength={20} // Limita a 20 caracteres
                        />
                        <Form.Control.Feedback type="invalid">
                          Código de la IPS es obligatorio.
                        </Form.Control.Feedback>
                      </Form.Group>

                      {/* Campo para seleccionar municipio */}
                      <Form.Group
                        controlId="id_municipio_id"
                        className="mb-3 w-100"
                      >
                        <Form.Label
                          className="fw-bold mb-2 mt-2"
                          htmlFor="id_municipio_id"
                        >
                          Municipio:
                        </Form.Label>
                        <Form.Select
                          required
                          id="id_municipio_id"
                          name="id_municipio_id"
                          value={id_municipio_id}
                          onChange={doubleLink}
                        >
                          <option value="">Selecciona un municipio</option>
                          {arrayMunicipio.map((municipio) => (
                            <option key={municipio.id} value={municipio.id}>
                              {municipio.nombre_municipio} - {" "}
                              {municipio?.id_deparment?.name_deparment}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          EL municipio es obligatorio.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="danger" onClick={handleClose2}>
                        <i className="fa-solid fa-backward"></i>&nbsp;Cancelar
                      </Button>
                      <Button
                        variant="success"
                        type="submit"
                        onClick={() => { }}
                      >
                        <i className="fa-solid fa-plus"></i>&nbsp;Guardar
                      </Button>
                    </Modal.Footer>
                  </Form>
                </Modal>

                <Modal
                  show={showUpdate}
                  onHide={handleCloseUpdate}
                  backdrop="static"
                  keyboard={false}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="text-center fw-bold">
                      <i className="fa-solid fa-pen"></i>
                      &nbsp;Actualizar los datos
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    IPS:
                    <strong>&nbsp;{objips.nombre_ips}</strong>
                    <br />
                    <div className="col-lg-12">
                      <Form
                        className="forms-sample"
                        validated={process}
                        noValidate
                        ref={formRef}
                      >
                        <div className="row">
                          {arrayUsers?.role === "ADMINISTRADOR" ? (<>
                            <div className="col-lg-12">
                              <Form.Group controlId="date_contract">
                                <Form.Label
                                  className="fw-bold mb-2 mt-2"
                                  htmlFor="date_contract"
                                >
                                  Fecha de contrato soporte y capacitación:
                                </Form.Label>
                                <Form.Control
                                  type="date"
                                  id="date_contract"
                                  name="date_contract"
                                  className="form-control"
                                  value={dateContract}
                                  onChange={(e) => setDateContract(e.target.value)}
                                  required
                                />
                              </Form.Group>
                            </div>
                            <div className="col-lg-12">
                              <Form.Group controlId="date_contract">
                                <Form.Label
                                  className="fw-bold mb-2 mt-2"
                                  htmlFor="date_contract"
                                >
                                  Fecha de contrato actualización 2025:
                                </Form.Label>
                                <Form.Control
                                  type="date"
                                  id="date_update2025"
                                  name="date_update2025"
                                  className="form-control"
                                  value={dateUpdate2025}
                                  onChange={(e) => setDateUpdate2025(e.target.value)}
                                  required
                                />
                              </Form.Group>
                            </div>
                            {/* Campo booleano have_lovelace */}
                            <div className="col-lg-4 mt-1">
                              <Form.Group controlId="have_lovelace">
                                <Form.Label
                                  className="fw-bold mt-2"
                                  htmlFor="date_contract"
                                >
                                  ¿Tiene lovelace?:
                                </Form.Label>
                                <Form.Check
                                  type="switch"
                                  checked={haveLovelace}
                                  onChange={(e) => setHaveLovelace(e.target.checked)}
                                  className="fw-bold fs-4"
                                />
                              </Form.Group>
                            </div>

                            {/* Campo booleano have_movile */}
                            <div className="col-lg-4 mt-1">
                              <Form.Group controlId="have_movile">
                                <Form.Label
                                  className="fw-bold mt-2"
                                  htmlFor="date_contract"
                                >
                                  ¿Tiene móvil?:
                                </Form.Label>
                                <Form.Check
                                  type="switch"
                                  checked={haveMovile}
                                  onChange={(e) => setHaveMovile(e.target.checked)}
                                  className="fw-bold fs-4"
                                />
                              </Form.Group>
                            </div>

                            {haveMovile && <Form.Group controlId="nombre_ips" className="mb-3 w-100">
                              <Form.Label
                                className="fw-bold mb-2 mt-2"
                                htmlFor="nombre_ips"
                              >
                                Cantidad de equipos móviles:
                              </Form.Label>
                              <Form.Control
                                required
                                type="text"
                                name="count_movile"
                                className="form-control"
                                id="count_movile"
                                placeholder="Escriba el nombre de la IPS"
                                value={count_movile}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  // Permitir solo números y limitar a 20 caracteres
                                  if (/^\d*$/.test(value) && value.length <= 20) {
                                    doubleLink(e); // Llama a tu función existente
                                  }
                                }}
                                autoComplete="off"
                                maxLength={25} // Limita a 60 caracteres
                              />
                              <Form.Control.Feedback type="invalid">
                                Cantidad de equipos móviles es obligatorio.
                              </Form.Control.Feedback>
                            </Form.Group>}
                          </>) : ("")}
                          <div className="col-lg-4 mt-1">
                            <Form.Group controlId="haveActualization">
                              <Form.Label
                                className="fw-bold mt-2"
                                htmlFor="haveActualization"
                              >
                                ¿Actualización?:
                              </Form.Label>
                              <Form.Check
                                type="switch"
                                checked={haveActualization}
                                onChange={(e) => setHaveActialization(e.target.checked)}
                                className="fw-bold fs-4"
                              />
                            </Form.Group>
                          </div>
                          <div className="col-lg-12">
                            <Form.Group controlId="date_contract">
                              <Form.Label
                                className="fw-bold mb-2 mt-2"
                                htmlFor="date_contract"
                              >
                                Fecha de actualización 2025:
                              </Form.Label>
                              <Form.Control
                                type="date"
                                id="dateUpdated2025"
                                name="dateUpdated2025"
                                className="form-control"
                                value={dateUpdated2025}
                                onChange={(e) => setDateUpdated2025(e.target.value)}
                                required
                              />
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group controlId="connection">
                              <Form.Label
                                className="fw-bold mb-2 mt-2"
                                htmlFor="connection"
                              >
                                Conexión:
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="connection"
                                name="connection"
                                className="form-control"
                                placeholder="Escriba la conexión"
                                value={connectiono}
                                onChange={(e) => setConnection(e.target.value)}
                                required
                              />
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group controlId="password_connection">
                              <Form.Label
                                className="fw-bold mb-2 mt-2"
                                htmlFor="password_connection"
                              >
                                Contraseña de conexión:
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="password_connection"
                                name="password_connection"
                                className="form-control"
                                placeholder="Escriba la contraseña"
                                value={passwordConnection}
                                onChange={(e) => setPasswordConnection(e.target.value)}
                                required
                              />
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group controlId="name_server">
                              <Form.Label
                                className="fw-bold mb-2 mt-2"
                                htmlFor="name_server"
                              >
                                Nombre del servidor:
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="name_server"
                                name="name_server"
                                className="form-control"
                                placeholder="Escriba el nombre"
                                value={nameServer}
                                onChange={(e) => setNameServer(e.target.value)}
                                required
                              />
                            </Form.Group>
                          </div>
                          <div className="col-lg-6">
                            <Form.Group controlId="password_server">
                              <Form.Label
                                className="fw-bold mb-2 mt-2"
                                htmlFor="password_server"
                              >
                                Contraseña del servidor:
                              </Form.Label>
                              <Form.Control
                                type="text"
                                id="password_server"
                                name="password_server"
                                className="form-control"
                                placeholder="Escriba la contraseña"
                                value={passwordServer}
                                onChange={(e) => setPasswordServer(e.target.value)}
                                required
                              />
                            </Form.Group>
                          </div>
                        </div>

                      </Form>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="danger"
                      onClick={() => {
                        setShowUpdate(false);
                      }}
                    >
                      <i className="fa-solid fa-backward"></i>
                      &nbsp;Cancelar
                    </Button>
                    <Button
                      variant="success"
                      onClick={() => {
                        sendUpdated(objips.id, dateContract);
                      }}
                    >
                      <i className="fa-solid fa-circle-check"></i>&nbsp;Confirmar
                    </Button>
                  </Modal.Footer>
                </Modal>

                <Modal
                  show={showUpActivation}
                  onHide={handleCloseUpdateActivation}
                  backdrop="static"
                  keyboard={false}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title className="text-center fw-bold">
                      <i className="fa-solid fa-calendar-days"></i>
                      &nbsp;Fecha de activación
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    IPS:
                    <strong>&nbsp;{objips.nombre_ips}</strong>
                    <br />
                    <div className="col-lg-12">
                      <Form
                        className="forms-sample"
                        validated={process}
                        noValidate
                        ref={formRef}
                      >
                        <div className="row">
                          <Form.Group controlId="dataA" className="mb-3 w-100">
                            <Form.Label
                              className="fw-bold mb-2 mt-2"
                              htmlFor="dataA"
                            >
                              Número de activación:
                            </Form.Label>
                            <Form.Control
                              required
                              type="text"
                              name="dataA"
                              id="dataA"
                              className="form-control"
                              placeholder="Ingrese el número de activación"
                              value={dataA}
                              onChange={(e) => {
                                // Quitar todo lo que no sea número y limitar a 25
                                const cleanValue = e.target.value.replace(/\D/g, "").slice(0, 25);
                                setDataA(cleanValue)
                              }}
                              autoComplete="off"
                              maxLength={25}
                            />
                            <Form.Control.Feedback type="invalid">
                              Número de activación.
                            </Form.Control.Feedback>
                          </Form.Group>
                        </div>

                      </Form>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="danger"
                      onClick={() => {
                        setShowUpdate(false);
                      }}
                    >
                      <i className="fa-solid fa-backward"></i>
                      &nbsp;Cancelar
                    </Button>
                    <Button
                      variant="success"
                      onClick={() => {
                        sendUpdatedDataA(objips.id);
                      }}
                    >
                      <i className="fa-solid fa-circle-check"></i>&nbsp;Confirmar
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};
